import { gql } from "gql";

export const SAVE_HR_SETTINGS = gql(/* GraphQL */ `
  mutation SaveHRSettings($settings: HrModuleSettingsInput!) {
    saveHrSettings(settings: $settings) {
      ...HrSettings
    }
  }
`);
